import { useSelector } from "react-redux";
import UniqueDefinitionsTable from "./UniqueDefinitionsTable";
import { useEffect } from "react";
import { UniqueDefinitionsEndpointLogic } from "../../../../logic/DataCollection/Unifier/UniqueDefinitionsEndpointLogic";
import { setLoading } from "../../../../features/uniqueDefSlice";
import {
  selectUserData,
  selectUserToken,
} from "../../../../features/userSlice";
import SimpleBackdrop from "../../../BackDrop/BackDrop";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const tableHeadings = {
  id: "ID",
  affiliate_system_interface: "Interface Name",
  destination_table: "Destination Table",
};

const UniqueDefinitions = () => {
  const loading = useSelector((state: any) => state.uniqueDefinition.loading);
  const { uniqueDefinitionDataAll, uniqueDefExecuteQueryDataForBrands } =
    useSelector((state: any) => state.uniqueDefinition);
  const dispatch = useDispatch();
  const oauthTokenHeader: any = useSelector(selectUserToken);
  const userDataForWebsite = useSelector(selectUserData);
  const websitePermissions = userDataForWebsite?.data?.website_permissions;

  let firstWebsiteKey: string | null = null;

  if (Array.isArray(websitePermissions) && websitePermissions.length > 0) {
    const firstObj = websitePermissions[0];
    firstWebsiteKey = Object.keys(firstObj)[0]; // ✅ this will give the key
  }
  const brandData = uniqueDefExecuteQueryDataForBrands?.query_output;
  const QUERY_ID_BRAND = "5768223068782592";
  useEffect(() => {
    const fetchData = async () => {
      dispatch(setLoading(true));
      try {
        await Promise.all([
          UniqueDefinitionsEndpointLogic.getAllUnifierUniqueDefinitions(
            oauthTokenHeader
          ),
          UniqueDefinitionsEndpointLogic.getUniqueDefExecuteQuery({
            oauthTokenHeader,
            queryId: QUERY_ID_BRAND,
            parameter: "a", // Provide the necessary parameter if required
            website_shared_uid: firstWebsiteKey || "", // Use the extracted key here
          }),
        ]);
      } catch (e: any) {
        console.error("Error fetching data:", e);
      } finally {
        dispatch(setLoading(false));
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oauthTokenHeader, dispatch]);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    const isCreateOpen = !!searchParams.get("open");
    const isDuplicateOpen = !!searchParams.get("openDup");

    if (!isCreateOpen && !isDuplicateOpen) {
      const params = new URLSearchParams(location.search);
      let shouldReplace = false;
      [
        "interfaceId",
        "interfaceName",
        "destinationTableName",
        "destinationTableId",
        "duplicate_id",
        "id",
      ].forEach((key) => {
        if (params.has(key)) {
          params.delete(key);
          shouldReplace = true;
        }
      });

      if (shouldReplace) {
        navigate(`${location.pathname}?${params.toString()}`, {
          replace: true,
        });
      }
    }
    // eslint-disable-next-line
  }, [location.search, location.pathname, navigate]);
  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <UniqueDefinitionsTable
            tableHeadings={tableHeadings}
            rows={uniqueDefinitionDataAll}
            brandData={brandData}
          />
        </>
      )}
    </>
  );
};

export default UniqueDefinitions;
